// removed by extract-text-webpack-plugin
module.exports = {"container":"styles__container___1dQk6","landing":"styles__landing___1PycK","show":"styles__show___PZKXE","withTransition":"styles__withTransition___24iKT","uconnLogo":"styles__uconnLogo___lDV88","rotate":"styles__rotate___2hzRu","fadein":"styles__fadein___1G1PZ","slideFromRight":"styles__slideFromRight___1lPdv","waves":"styles__waves___2_tjC"};


//////////////////
// WEBPACK FOOTER
// ./resources/assets/js/containers/Landing/styles.scss
// module id = ./resources/assets/js/containers/Landing/styles.scss
// module chunks = 0